/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type stations_stations$ref: FragmentReference;
declare export opaque type stations_stations$fragmentType: stations_stations$ref;
export type stations_stations = $ReadOnlyArray<{|
  +name: ?string,
  +dist: ?number,
  +lines: ?$ReadOnlyArray<?{|
    +name: ?string,
    +type: ?string,
  |}>,
  +$refType: stations_stations$ref,
|}>;
export type stations_stations$data = stations_stations;
export type stations_stations$key = $ReadOnlyArray<{
  +$data?: stations_stations$data,
  +$fragmentRefs: stations_stations$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "stations_stations",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GeoTransportLine",
      "kind": "LinkedField",
      "name": "lines",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GeoTransportStation",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c4710605eaccd6804df9883d79e806d7';

module.exports = node;
